import { render, staticRenderFns } from "./TransferenciasJugadoresListView.vue?vue&type=template&id=8ed49330&"
import script from "./TransferenciasJugadoresListView.vue?vue&type=script&lang=js&"
export * from "./TransferenciasJugadoresListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports